/** Join class names, dropping falsy entries. Tiny on purpose — no clsx dependency for one helper. */
export function cx(...parts: Array<string | false | null | undefined>): string {
	return parts.filter(Boolean).join(" ");
}
